import type { JSX } from 'react';

import { Button } from '@change/ds-core-ui/next';

export function SubmitButton({
	hasValidationErrors,
	loading,
}: {
	hasValidationErrors: boolean;
	loading: boolean;
}): JSX.Element {
	return (
		<Button
			type="submit"
			data-testid="submit"
			data-qa="submit"
			disabled={hasValidationErrors || loading}
			className="w-full md:w-[200px]"
			variant="primary"
		>
			Post update
		</Button>
	);
}
